import React from "react";
import PropTypes from "prop-types";
import LossToActionOverview from "../../LossToActionOverview";

const DispatchPriorityGlobalOverviewTable = ({
  data,
  columns,
  paginationData = {},
  sortingData = {},
  handlePageChange = null,
  isLoading = false,
}) => {
  const scrollableColumnsArray = [
    "% Order Loss Mitigation",
    "% Overall Loss Mitigation",
    "Total MSTN Loss Impacted Packs",
    "Total MSTN Loss Mitigation",
    "Order Loss Impact Packs",
    "Order Loss Mitigation",
    "Overall Loss Mitigation",
    "Shipment Details",
    "% Total MSTN Loss Mitigation",
    "Weighted Score",
    "Day wise Value Mitigation",
    "Order Loss Details",
  ];
  return (
    <LossToActionOverview
      data={data}
      columns={columns}
      paginationData={paginationData}
      sortingData={sortingData}
      handlePageChange={handlePageChange}
      isLoading={isLoading}
      scrollableColumnsArray={scrollableColumnsArray}
      totalColumnName="Shipment Number"
      fixedColumnName="Shipment Detail"
      tableType="Dispatch Priority"
    />
  );
};

DispatchPriorityGlobalOverviewTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  paginationData: PropTypes.shape({
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    totalRecords: PropTypes.number,
  }),
  sortingData: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  handlePageChange: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default DispatchPriorityGlobalOverviewTable;
